/**
 * Hier koennen selbstdefinierte jQuery-Erweiterungen definiert werden.
 *
 */

/**
 * Kehrt die Reihenfolge Elemente in der aktuellen Auswahl um.
 */
jQuery.fn.reverse = [].reverse;

/**
 * Gibt zurueck, ob die aktuelle Auswahl mind. ein Element beinhaltet.
 *
 * @returns {Boolean}
 */
jQuery.fn.exists = function () {
    return this.length > 0;
};

/**
 * Shows tooltips with html content just add class tooltipWithHtml.
 */
$(document).ready(function () {
    $('.tooltipWithHtml').tooltip({html: true});
});

/**
 * deserialize a from by a serialized form string
 *
 * @param {type} serializedString
 * @returns {$.fn}
 */
$.fn.deserialize = function (serializedString)
{
    var $form = $(this);
    $form[0].reset();    // (A) optional
    serializedString = serializedString.replace(/\+/g, '%20'); // (B)
    var formFieldArray = serializedString.split("&");

    // Loop over all name-value pairs
    $.each(formFieldArray, function (i, pair) {
        var nameValue = pair.split("=");
        var name = decodeURIComponent(nameValue[0]); // (C)
        var value = decodeURIComponent(nameValue[1]);
        // Find one or more fields
        var $field = $form.find('[name="' + name + '"]');
        // Checkboxes and Radio types need to be handled differently
        if ($field.length > 0) {
            if ($field[0].type === "checkbox" || $field[0].type === "radio") {
                value === 'on' ? $field.prop('checked', true) : $field.prop('checked', false);
            } else if ($field.is('input') || $field.is('textarea')) { // input, textarea
                $field.val(value);
            }
            else if ($field.is('input.select-accessible-input')) {
                $field.trigger('select-option-selected-change', {id:  value});
            }
        }
    });
    return this;
}

/**
 *
 * @param {string} status
 * @returns {void}
 */
$.overlay = function (status) {
    var overlayNode = $('body').find('#ajax-overlay');
    if (status === 'show' && overlayNode.length === 0) {
        $('body').prepend(`<div id="ajax-overlay" class="ajax-overlay"><div class="ajax-outer"><div class="ajax-middle"><div class="ajax-inner">${window.Esearcher.handler.tabs.loadingIconDefault}</div></div></div></div>`);
    }
    else if (status === 'remove' && overlayNode.length > 0) {
        overlayNode.remove();
    }
}
